goog.provide("shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$files$spreadsheet_svg");
shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg = shadow.js.nativeProvides["src/svg/wpp/files/spreadsheet.svg"] = shadow$bridge("src/svg/wpp/files/spreadsheet.svg");
module$shadow_js_shim_module$src$svg$wpp$files$spreadsheet_svg.default = shadow.js.shim.module$src$svg$wpp$files$spreadsheet_svg;
